export default class Models {
  constructor(box21_api) {
    this.api = box21_api;
  }

  async activate(model_id) {
    let formData = new FormData();
    formData.append("model_id", JSON.stringify(model_id));
    return this.api.post_with_token("/activate-model", formData);
  }

  async deactivate(model_id) {
    let formData = new FormData();
    formData.append("model_id", JSON.stringify(model_id));
    return this.api.post_with_token("/deactivate-model", formData);
  }

  async archive(model_id) {
    let formData = new FormData();
    formData.append("model_id", JSON.stringify(model_id));
    return this.api.post_with_token("/archive-model", formData);
  }

  async unarchive(model_id) {
    let formData = new FormData();
    formData.append("model_id", JSON.stringify(model_id));
    return this.api.post_with_token("/unarchive-model", formData);
  }

  async add(saved_filename, name) {
    let formData = new FormData();
    formData.set("saved_filename", saved_filename);
    formData.set("name", name);
    formData.set("project_id", sessionStorage.getItem("project_id"));
    return this.api.post_with_token("/add-model", formData);
  }

  async delete(model) {
    let formData = new FormData();
    formData.append("project_id", sessionStorage.getItem("project_id"));
    formData.append("model_id", JSON.stringify(model.id));
    return this.api.post_with_token("/model/delete", formData);
  }

  async all(type) {
    let formData = new FormData();
    if (!type) {
      type = "yolo5,mobilenet_large,deeplabcut";
    }
    formData.append("type", type);
    let project_id = sessionStorage.getItem("project_id");
    formData.append("project_id", project_id);
    if (project_id == "false" || project_id == false) {
      return [];
    }
    return this.api.post_with_token("/models", formData);
  }

  async get_model_preds(asset_id, model_id, websocketsToken = null) {
    let formData = new FormData();
    formData.append("project_id", sessionStorage.getItem("project_id"));
    formData.append("asset_id", asset_id);
    formData.append("model_id", model_id);
    if (websocketsToken) {
      formData.append("websocketsToken", websocketsToken);
    }
    return this.api.post_with_token("/preds", formData);
  }

  async calculate_confusion_matrix(model_id) {
    let formData = new FormData();
    formData.append("project_id", sessionStorage.getItem("project_id"));
    formData.append("model_id", model_id);
    return this.api.post_with_token("/conf-matrix-items/calculate", formData);
  }

  async getTrainJob(model_id) {
    const formData = new FormData();
    formData.append("project_id", sessionStorage.getItem("project_id"));
    formData.append("model_id", model_id);
    return this.api.post_with_token("/model/train-job", formData);
  }

  bundleDownloadUrl(model_id) {
    const params = new URLSearchParams({
      project_id: sessionStorage.getItem("project_id"),
      model_id: String(model_id),
      token: localStorage.token || "",
    });
    return `${this.api.api_url}/model/bundle?${params.toString()}`;
  }

  async createLiveDemo(model_id) {
    const formData = new FormData();
    formData.append("project_id", sessionStorage.getItem("project_id"));
    formData.append("model_id", String(model_id));
    return this.api.post_with_token("/models/live-demo", formData);
  }

  async createDownloadLink(model_id) {
    const formData = new FormData();
    formData.append("project_id", sessionStorage.getItem("project_id"));
    formData.append("model_id", String(model_id));
    return this.api.post_with_token("/models/download-link", formData);
  }

  async importBundle(file, onProgress) {
    const { v4: uuidV4 } = require("uuid");
    const chunkSize = 500000;
    const totalChunks = Math.max(1, Math.ceil(file.size / chunkSize));
    const uploadId = uuidV4();
    let response = null;
    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);
      const isLast = i === totalChunks - 1;

      let formData = new FormData();
      formData.append("project_id", sessionStorage.getItem("project_id"));
      formData.append("id", uploadId);
      formData.append("original_name", file.name);
      formData.append("chunk_offset", String(start));
      formData.append("is_last", isLast ? "true" : "false");
      formData.append("file", chunk, `${file.name}.part`);

      response = await this.api.post_with_token("/model/import-bundle", formData);
      if (!response || response.error || (response.data && response.data.error)) {
        return response;
      }
      if (onProgress) {
        onProgress(Math.round(((i + 1) / totalChunks) * 100));
      }
    }
    return response;
  }
}
